import { JSX } from "react";

const NetworkProviderBreakdownDescription = (): JSX.Element => {
  return <>
    <p>
      The Provider Breakdown card displays a visual snapshot of your network&apos;s integrity at-a-glance. It shows how many providers have:
    </p>
    <ul>
        <li><b>Blue</b>: Passed all integrity checks</li>
        <li><b>Yellow</b>: Triggered at least one warning</li>
        <li><b>Red</b>: Triggered at least one alert</li>
      </ul>
    <p>
      This breakdown helps to quickly understand the proportion of your network that may need attention and identifies the types of integrity issues that exist.
    </p>
    <p>
      <i>Note: Blue, Yellow, and Red bands are mutually exclusive, meaning if a provider has both an alert and a warning, they will be counted in the Red grouping.</i>
    </p>
    <p>
      Provider counts represent Unique Access Points.
    </p>
  </>;
}

export { NetworkProviderBreakdownDescription };